import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = {
  key: 0,
  class: "row m-auto"
}
const _hoisted_4 = { class: "col-md-12 px-5 py-2" }
const _hoisted_5 = {
  key: 0,
  class: "py-4"
}
const _hoisted_6 = { class: "w-100 session-bar" }
const _hoisted_7 = {
  key: 0,
  class: "col-1 d-flex flex-column justify-content-center"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "loading-area"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pagination = _resolveComponent("pagination")!
  const _component_loading = _resolveComponent("loading")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Session Counter", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.partners.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners.slice(_ctx.page_start,_ctx.page_end), (partner) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: partner.id,
                        class: "row py-2"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.is_client_admin ? 'col-12' : 'col-11')
                        }, [
                          _createElementVNode("p", null, _toDisplayString(partner.long_name) + " - " + _toDisplayString(partner.usage) + "% (" + _toDisplayString(partner.used_seats) + "/" + _toDisplayString(partner.seats) + ")", 1),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", {
                              class: _normalizeClass(partner.usage >= 80 ? 'bg-danger session-bar' : 'bg-primary session-bar'),
                              style: _normalizeStyle('width:' + partner.usage + '%')
                            }, null, 6)
                          ])
                        ], 2),
                        (!_ctx.is_client_admin && partner.usage >= 80)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-primary",
                                onClick: ($event: any) => (_ctx.clientList(partner))
                              }, _cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "fas fa-envelope" }, null, -1)
                              ]), 8, _hoisted_8)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_ctx.partners.length > 5)
                      ? (_openBlock(), _createBlock(_component_pagination, {
                          key: 0,
                          items: _ctx.partners,
                          page_start: _ctx.page_start,
                          page_end: _ctx.page_end,
                          onNextPage: _ctx.nextPage,
                          onPreviousPage: _ctx.previousPage,
                          label: "Co-Brands"
                        }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "row py-4" }, [
                      _createElementVNode("div", { class: "col-12" }, [
                        _createElementVNode("p", null, "No partners with session data available.")
                      ])
                    ], -1)
                  ])))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_loading, {
              active: _ctx.loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ])),
      _createVNode(_component_modal, {
        modelValue: _ctx.client_list_modal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.client_list_modal) = $event))
      }, {
        header: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.client_list_title), 1)
        ]),
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("p", null, "Client Administrators", -1)),
          (_ctx.client_list.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client_list, (client) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: client.id
                  }, _toDisplayString(client.first_name) + " " + _toDisplayString(client.last_name) + " (" + _toDisplayString(client.email) + ") ", 1))
                }), 128)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "float-end btn btn-sm btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyEmails(_ctx.copy_list)))
                  }, "Copy Email Addresses")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("p", null, "No client administrators associated to " + _toDisplayString(_ctx.client_list_title) + ".", 1)
              ]))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}